import { CanDeactivateFn } from '@angular/router';

export interface CanDeactivateReprocessing {
  isReprocessing(): boolean;
}

export const reprocessingGuard: CanDeactivateFn<CanDeactivateReprocessing> = (component) => {
  return !component.isReprocessing();
};
